const extraRouters = [
  {
    path: "/process-list/preview", // 查看工作流流程
    component: () => import("@/views/Backend/AdminEdit/Workflow"),
    name: "process-preview",
    meta: { hideNav: true, preview: true }
  }
]

export default extraRouters
